package empiresmp.feature.main.presentation.model

enum class MainPagerModelDirection {
    LTR, RTL
}
